import _createForOfIteratorHelper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import Gikam from '../core/gikam-core.js';
import { Sequence } from '@/gikam/js/core/sequence';

var Base = /*#__PURE__*/function () {
  function Base(name) {
    _classCallCheck(this, Base);

    this.$type = name || 'comp';
    this._model = null;
    this._$childrenReadyNum = 0;
    this.$readyCallback = [];
    this.$state = 'begin';
    this.$children = [];
    this.$storeCompIndex = 0;
    this.$fromPageConfig = false;
  } // eslint-disable-next-line complexity


  _createClass(Base, [{
    key: "initialize",
    value: function initialize(param, defaultOptions) {
      if (!this.$window) {
        this.$window = param ? param.$window : null;
      }

      this.$parent = param ? param.$parent : null;

      if (param) {
        //页面切换时是否对组件进行刷新
        this.$canRefreshPageSwitch = param.url ? true : false;
        param.$parent && delete param.$parent; // 如果父组件是tab，则存储title属性用于页面配置

        this.$title = param.$title;
        Object.assign(param, this.getPageEditOptions(param));

        if (!param.id) {
          param.id = Sequence.nextWithTime().toString();
        }

        Gikam.compInstanceContainer[param.id] = this;

        if (this.$window) {
          this.$window.compInstanceContainer[param.id] = this;
        }
      }

      this.options = Gikam.deepExtend(defaultOptions, param);
      this.registerListeners();
      this.$notifyWindow();
      this.$initParent();
      this.$parent && this.$parent.$updateChildren(this);
      return this;
    }
  }, {
    key: "getPageEditOptions",
    value: function getPageEditOptions(param) {
      var pageEditOptions = {};

      if (!this.$window) {
        return pageEditOptions;
      }

      var pageEditConfig = Gikam.compConfigManager[this.$window.getMainPageUrl()];

      if (pageEditConfig && pageEditConfig[param.id]) {
        this.$fromPageConfig = true;
        return pageEditConfig[param.id];
      }

      return pageEditOptions;
    }
  }, {
    key: "registerListeners",
    value: function registerListeners() {
      var _this = this;

      this.listeners && Gikam.each(this.options, function (property, value) {
        var name = Gikam.toInitialLowerCase(property.replace('on', ''));
        _this.listeners[name] && (_this.listeners[name] = value);
      });
    }
  }, {
    key: "trigger",
    value: function trigger(eventName) {
      var _this$listeners$event;

      if (!this.listeners) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$listeners$event = this.listeners[eventName]) === null || _this$listeners$event === void 0 ? void 0 : _this$listeners$event.apply(this, args);
    }
    /**
     * @description 临时以后直接去掉
     * @memberof Base
     */

  }, {
    key: "bindInstance",
    value: function bindInstance() {}
    /**
     * @description 在window中注册组件
     * @private
     * @memberof Grid
     */

  }, {
    key: "$notifyWindow",
    value: function $notifyWindow() {
      if (!this.$window) {
        return;
      }

      if (this.$window === this) {
        return;
      }

      this.$window.$addStoreComp(this.$type, this);
      this.$storeCompIndex = this.$window.$compStore[this.$type].length - 1;
    }
    /**
     * @description 渲染成功之后，通知组件容器，通知通过id异步获取组件的地方
     * @private
     * @memberof Base
     */

  }, {
    key: "notify",
    value: function notify() {
      var pro = Gikam.createdComponent[this.options.id];

      if (pro) {
        pro.resolve(this);
        delete Gikam.createdComponent[this.options.id];
      }
    }
    /**
     * @description 更新子组件渲染成功的数量
     * @private
     * @memberof Base
     */

  }, {
    key: "$updateChildrenReadyNum",
    value: function $updateChildrenReadyNum() {
      this.$childrenReadyNum++;
    }
    /**
     * @description 绑定事件
     * @param {String} event 事件名称
     * @param {Function} callback 回调
     * @public
     * @memberof Base
     */

  }, {
    key: "on",
    value: function on(event, callback) {
      if (!this.listeners) {
        return;
      }

      if (!this.listeners[name]) {
        Gikam.error("".concat(event, " not exists"));
        return;
      }

      this.listeners[name] = callback;
    }
  }, {
    key: "model",
    get: function get() {
      return this._model;
    },
    set: function set(model) {
      var _this2 = this;

      this._model = model;
      model === null || model === void 0 ? void 0 : model.$nextTick(function () {
        if (_this2.$lastChild && _this2.$parent) {
          _this2.$parent.$updateChildrenReadyNum();
        }

        _this2.$state = 'end';
      });
    }
  }, {
    key: "$childrenReadyNum",
    get: function get() {
      return this._$childrenReadyNum;
    }
    /**
     * @description 初始化父组件
     * @private
     * @memberof Base
     */
    ,
    set: function set(val) {
      var _this3 = this;

      this._$childrenReadyNum = val;

      if (val === this.$children.length) {
        Gikam.trigger(this.options, 'ready', this);
        this.$state = 'end';
        this.$parent && this.$parent.$updateChildrenReadyNum();
        this.$readyCallback.forEach(function (item) {
          return item.call(_this3);
        });
      }
    }
  }, {
    key: "$initParent",
    value: function $initParent() {
      if (this.$parent) {
        return;
      }

      if (!this.options.renderTo) {
        return;
      }

      this.$parent = Gikam.getInstance(this.options.renderTo);
    }
    /**
     * @description 所有组件加载完毕之后的回调
     * @public
     * @memberof Window
     */

  }, {
    key: "onReady",
    value: function onReady(callback) {
      this.$state === 'begin' ? this.$readyCallback.push(callback) : callback.apply(this);
    }
  }, {
    key: "$updateChildren",
    value: function $updateChildren(child) {
      if (!this.$children.includes(child)) {
        this.$children.push(child);
      }
    }
    /**
     * @description 销毁
     * @returns
     * @memberof Base
     */

  }, {
    key: "$destroy",
    value: function $destroy() {
      var _this$$beforeDestroy,
          _this$store,
          _this4 = this;

      delete Gikam.compInstanceContainer[this.options.id];

      if (this.$window) {
        delete this.$window.compInstanceContainer[this.options.id];
      }

      (_this$$beforeDestroy = this.$beforeDestroy) === null || _this$$beforeDestroy === void 0 ? void 0 : _this$$beforeDestroy.call(this);

      var _iterator = _createForOfIteratorHelper(this.$children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _childComp$$destroy;

          var childComp = _step.value;
          (_childComp$$destroy = childComp.$destroy) === null || _childComp$$destroy === void 0 ? void 0 : _childComp$$destroy.call(childComp);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if ((_this$store = this.store) !== null && _this$store !== void 0 && _this$store.state.$window) {
        this.store.state.$window = null;
      }

      Object.keys(this).forEach(function (key) {
        if (key === 'model' || key === '_model') {
          return;
        }

        _this4[key] = null;
      });

      if (!this.model) {
        return;
      }

      this.model.$destroy();
      Gikam.removeDom(this.model.$el);
      this.model = null;
    }
  }]);

  return Base;
}();

export { Base as default };